import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 30 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="font-mono font-bold text-xl tracking-widest text-white bg-red-600 px-3 py-1 rounded" data-id="element-17">
      {formatTime(timeLeft)}
    </div>;
}